import { render, staticRenderFns } from "./InsuranceInfo.vue?vue&type=template&id=8b9b700a&"
import script from "./InsuranceInfo.vue?vue&type=script&lang=ts&"
export * from "./InsuranceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports